// types.ts (or top of page)
export interface LoanMonthData {
  month: string; // "March 2025"
  leads: number;
  customers: number;
  loanIssued: number;
  totalDisbursed: number;
  expected: number;
  collected: number;
  outstanding: number;
  collectionRate: number;
  expenses: number;
  revenue: number;
}

export interface MonthlyPerfApiRes {
  from: string;
  to: string;
  data: LoanMonthData[];
  totals: {
    leads: number;
    customers: number;
    loanIssued: number;
    totalDisbursed: number;
    expected: number;
    collected: number;
    outstanding: number;
    expenses: number;
    revenue: number;
  };
}

export const fmtKES = (n: number) => new Intl.NumberFormat("en-KE").format(Math.round(n || 0));
export const fmtShort = (n: number) => {
  const x = n || 0;
  if (Math.abs(x) >= 1_000_000_000) return `${(x / 1_000_000_000).toFixed(1)}B`;
  if (Math.abs(x) >= 1_000_000) return `${(x / 1_000_000).toFixed(1)}M`;
  if (Math.abs(x) >= 1_000) return `${(x / 1_000).toFixed(1)}K`;
  return `${Math.round(x)}`;
};

/////////////////////////////////////////////////////////////////////////////////
export interface LoanMonthData {
  month: string;
  leads: number;
  customers: number;
  loanIssued: number;
  totalDisbursed: number;
  expected: number;
  collected: number;
  outstanding: number;
  collectionRate: number;
  expenses: number;
  revenue: number;
}



export const totals = {
  leads: 29905,
  customers: 5463,
  loanIssued: 63311,
  totalDisbursed: 810627700,
  expected: 993723724,
  collected: 872477015,
  outstanding: 121246708,
  expenses: 0,
  revenue: 183096024,
};

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US").format(value);
}

